import MINE from './mobileModule/mine.js'
import FIND from './mobileModule/find.js'
import CHAT from './mobileModule/chat.js'
const mobileRoutes = [
    ...MINE,
    ...FIND,
    ...CHAT,
    {
        path: '/',
        component: () => import('@/pages/Mobile/TopChat/index.vue'),
        redirect: localStorage.getItem('isAgreement') ? '/chat' : '/useragreement',
        children:[
            {
                path: 'chat',
                component: () => import('@/pages/Mobile/Chat/index.vue'),
                meta:{
                    title:"聊天",
                    requiresAuth:false,
                }
            },
            {
                path: 'find',
                component: () => import('@/pages/Mobile/Find/index.vue'),
                meta:{
                    title:"发现",
                    requiresAuth:false,
                }
            },
            {
                path: 'mine',
                component: () => import('@/pages/Mobile/Mine/index.vue'),
                meta:{
                    title:"我的",
                }
            },
        ]
    },
]

export default mobileRoutes;